var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assignment-view w-100"},[_c('folder-settings',{attrs:{"folder-parent-id":_vm.folder.parentId,"folder-name":_vm.folder.name,"grading-details":_vm.folder.gradingDetails}},[(_vm.folder.gradingDetails)?_c('folder-tags',{attrs:{"grading-details":_vm.folder.gradingDetails}}):_vm._e()],1),_c('essays-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }